module.exports = __webpack_public_path__ + "assets/88c959ef3de5f84db6e3f9956fb75290.png";